var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.person)?_c('span',{staticClass:"person-label text-truncate",domProps:{"textContent":_vm._s(`${_vm.person.firstName || _vm.person.lastName}`)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }